import { htmlSafe } from '@ember/template';
import type { SafeString } from '@ember/template/-private/handlebars';
import Component from '@glimmer/component';

interface DynamicColorSvgSignature {
  Args: {
    squareColor: string;
  };
  Element: HTMLDivElement;
}

export default class DynamicColorSvg extends Component<DynamicColorSvgSignature> {
  get backgroundStyle(): SafeString {
    return htmlSafe(`background-color: ${this.args.squareColor}`);
  }

  <template>
    <div data-test-dynamic-color class="w-9 h-7 rounded-lg" style={{this.backgroundStyle}} ...attributes></div>
  </template>
}
